export default {
    page_title: 'Widget List',
    create_new: 'Create a New Widget',
    new: 'New Widget',
    update: 'Edit Widget',
    price: 'Price',
    no_items: 'No results found',
    reduced_price: 'Discounted Price',
    errors: {
        image_required: 'Image is required for all rows',
        slug: 'ID is required for all rows',
        config_id_required: 'Config ID is required for all rows',
        product_required: 'Product is required for all rows',
    },
    form_actions: {
        select_type: 'Select Type',
        select_product: 'Select Product',
        select_image: 'Select Image',
        select_id: 'Add an ID',
        select_config_id: 'Add Config ID',
        select_id_info: 'Required for easier identification by other sources',
        select_provider: 'Select Provider',
        add_row: 'Add Product',
        save: 'Save'
    },
    reason: {
        inactive_product: 'Product was deactivated by the provider',
        invalid_id: 'Product was deleted from the database',
    },
    table: {
        header: {
            data: 'Data',
            id: 'ID',
            type: 'Type',
            available_start: 'Available Start',
            available_end: 'Available End',
            created_at: 'Created At',
            updated_at: 'Updated At',
            status: 'Status',
        }
    },
    modal: {
        select_product_title: 'Selec Product',
        provider: 'Provider',
        select_provider_first: 'Select Provider',
        name: 'Name',
        brand: 'Brand',
        price: 'Price',
        action: 'Action',
    }
}
